var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#3498DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.436 16H144.436V496H243.436V16Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 305.5V206.5H16V305.5H496Z",
    fill: "#F1C40F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 272.5V239.5H16V272.5H496Z",
    fill: "#E32D3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.436 16H177.436V496H210.436V16Z",
    fill: "#E32D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAx);
export default __webpack_public_path__ + "static/media/AX.26f43708cfa638adeb7bad19d0ac8c8c.svg";
export { ForwardRef as ReactComponent };